import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldLayoutComponent } from './form-field-layout.component.js';
import { TextFormFieldComponent } from './fields/text-form-field.component.js';
import { FormSaveButtonComponent } from './form-save-button.component.js';
import { SelectItemFieldComponent } from './fields/select-item-field.component.js';
import { TextAreaFormFieldComponent } from './fields/text-area-form-field.component.js';
import { FileFormFieldComponent } from './fields/file-form-field.component.js';
import { VideoFormFieldComponent } from './fields/video-form-field.component.js';
import { ButtonModule } from '../buttons/index.js';
import { DividerModule } from '../divider/index.js';
import { AppFlexModule } from '../flex/index.js';
import { VideoModule } from '../video/index.js';
import { ChipsModule } from '../chips/index.js';
import { IconModule } from '../icons/index.js';
import { TooltipModule } from '../tooltip/tooltip.module.js';
import { ConfirmModule } from '../confirm/confirm.module.js';
import { ImagesModule } from 'lib/images/images.module.js';
import { CommonModule } from '@angular/common';
import { CropModule } from '../crop/index.js';
import { FlatpickrModule } from 'angularx-flatpickr';
import { NumberFormFieldComponent } from './fields/number-form-field.component.js';
import { TypographyModule } from 'lib/typography/index.js';
import { WeightFormFieldComponent } from './fields/weight-form-field.component.js';
import { HeightFormFieldComponent } from './fields/height-form-field.component.js';
import { PasswordFormFieldComponent } from './fields/password-form-field.component.js';
import { DateTimeFormFieldComponent } from './fields/date-time-form-field.component.js';
import { IconSelectionFormFieldComponent } from './fields/icon-selection-form-field.component.js';
import { MessagesModule } from '../messages/messages.module.js';
import { DateFormFieldComponent } from './fields/date-form-field.component.js';
import { FormInputsModule } from '../form-inputs/form-inputs.module.js';
import { EmojiModule } from '../emoji/index.js';
import { LoaderModule } from '../loader/loader.module.js';

@NgModule({
	declarations: [
		TextFormFieldComponent,
		FormFieldLayoutComponent,
		FormSaveButtonComponent,
		SelectItemFieldComponent,
		TextAreaFormFieldComponent,
		FileFormFieldComponent,
		VideoFormFieldComponent,
		NumberFormFieldComponent,
		WeightFormFieldComponent,
		HeightFormFieldComponent,
		PasswordFormFieldComponent,
		DateTimeFormFieldComponent,
		IconSelectionFormFieldComponent,
		DateFormFieldComponent
	],
	exports: [
		TextFormFieldComponent,
		FormFieldLayoutComponent,
		FormSaveButtonComponent,
		SelectItemFieldComponent,
		TextAreaFormFieldComponent,
		FileFormFieldComponent,
		VideoFormFieldComponent,
		NumberFormFieldComponent,
		WeightFormFieldComponent,
		HeightFormFieldComponent,
		PasswordFormFieldComponent,
		DateTimeFormFieldComponent,
		IconSelectionFormFieldComponent,
		DateFormFieldComponent
	],
	imports: [
		EmojiModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		ButtonModule,
		DividerModule,
		AppFlexModule,
		VideoModule,
		ChipsModule,
		IconModule,
		TooltipModule,
		ConfirmModule,
		ImagesModule,
		CropModule,
		TypographyModule,
		FlatpickrModule,
		MessagesModule,
		FormInputsModule,
		LoaderModule
	]
})
export class FormModule {}
